import { useEffect } from 'react'
import { DEFAULT_SOCIAL_IMAGE, getSeoForPath, getStructuredData } from '@/lib/seo'

function setMeta(selector, attributes) {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement('meta')
    document.head.appendChild(element)
  }
  Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value))
}

export default function Seo({ path }) {
  useEffect(() => {
    const seo = getSeoForPath(path)
    document.title = seo.title

    setMeta('meta[name="description"]', { name: 'description', content: seo.description })
    setMeta('meta[name="robots"]', {
      name: 'robots',
      content: seo.robots || 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1',
    })
    setMeta('meta[property="og:type"]', { property: 'og:type', content: 'website' })
    setMeta('meta[property="og:site_name"]', { property: 'og:site_name', content: 'Retira.app' })
    setMeta('meta[property="og:title"]', { property: 'og:title', content: seo.title })
    setMeta('meta[property="og:description"]', { property: 'og:description', content: seo.description })
    setMeta('meta[property="og:url"]', { property: 'og:url', content: seo.canonical })
    setMeta('meta[property="og:image"]', { property: 'og:image', content: DEFAULT_SOCIAL_IMAGE })
    setMeta('meta[property="og:image:alt"]', { property: 'og:image:alt', content: 'Retira.app logo' })
    setMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary' })
    setMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: seo.title })
    setMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: seo.description })
    setMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: DEFAULT_SOCIAL_IMAGE })
    setMeta('meta[name="twitter:image:alt"]', { name: 'twitter:image:alt', content: 'Retira.app logo' })

    let canonical = document.head.querySelector('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.setAttribute('rel', 'canonical')
      document.head.appendChild(canonical)
    }
    canonical.setAttribute('href', seo.canonical)

    let structuredData = document.head.querySelector('#retira-structured-data')
    if (!structuredData) {
      structuredData = document.createElement('script')
      structuredData.id = 'retira-structured-data'
      structuredData.type = 'application/ld+json'
      document.head.appendChild(structuredData)
    }
    structuredData.textContent = JSON.stringify(getStructuredData(path))
  }, [path])

  return null
}
